import { GiphyFetch } from "@giphy/js-fetch-api";
// use @giphy/js-fetch-api to fetch gifs, instantiate with your api key
export const gf = new GiphyFetch(process.env.REACT_APP_GIPHY_API_KEY);
